import { FormItem, Input } from 'formik-antd'
import { FormikErrors } from 'formik'
import * as React from 'react'
import { useState } from 'react'
import * as Yup from 'yup'

import { FormProps, Form, FormValues } from '../form'
import { ConversationIcon, PlusIcon } from '../icons'

import * as styles from './CreateNewDiscussionForm.module.less'

export interface CreateNewDiscussionFormProps {
	submit: (values: FormValues) => Promise<FormikErrors<FormValues>>
}

export const CreateNewDiscussionForm: React.FC<CreateNewDiscussionFormProps> = (props) => {
	const [ isVisible, setIsVisible ] = useState(false)
	const titleNotLongEnough = 'Title must be at least 3 characters'

	const validationSchema = Yup.object().shape({
		title: Yup.string().min(3, titleNotLongEnough).max(255).required()
	})

	const form = (
		<React.Fragment>
			<FormItem name='title'>
				<Input name='title' placeholder='Discussion title' />
			</FormItem>
		</React.Fragment>
	)

	const formProps: FormProps = {
		errorText: 'Could not create the Discussion',
		form,
		formTitle: (
			<h3 style={{ color: '#172b4d' }}>
				<span>
					<ConversationIcon /> Add new Discussion
				</span>
			</h3>
		),
		submit: props.submit,
		successText: 'Discussion created',
		validationSchema,
		modal: true,
		isVisible,
		hide: () => setIsVisible(false)
	}

	return (
		<React.Fragment>
			<a onClick={() => setIsVisible(true)}>
				<PlusIcon />
				<span className={styles.addNewDiscussion}>Add new Discussion</span>
			</a>
			<Form {...formProps} />
		</React.Fragment>
	)
}
